import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FieldBase from '../Base/FieldBase';
import { CLASS_MODIFIERS } from '../../Utility/_formsConfig';

const RadioButtonList = ({ name, register, label, defaultValue, alive, options, errors, incrementor, validation = {} }) => {

    const [value, setValue] = useState(typeof defaultValue !== 'undefined' ? defaultValue : null);

    const onValueChange = (val) => {
        setValue(val.target.value);
        return val.target.value;
    }  

    const renderRadioButton = (radio, i) => {

        const checked = value == radio.value;

        return <div className="radio" key={`${radio.label}_${i}`}>
            <label>
                <div className="radio__control-container">
                    <div className={`radio__control ${checked ? 'checked' : ''}`} tabIndex="1" role="radio" aria-checked={checked} >
                        <input {...register(name, validation)} type="radio" onChange={onValueChange} checked={checked} value={radio.value} />
                        <span className="radio__control-mask"><span></span></span>
                    </div>
                </div>
                <span className="radio__label">
                    {radio.label}
                </span>
            </label>
        </div>
    }

    return <FieldBase {...{ errors, alive, ['classModifier']: CLASS_MODIFIERS.RadioButtonList, label, incrementor }}>
        <div className="form-field--radio-button-list__list" role="radiogroup">
            {options?.map((radio, i) => renderRadioButton(radio, i))}
        </div>
    </FieldBase>
};

export default RadioButtonList;

RadioButtonList.propTypes = {
    incrementor: PropTypes.number.isRequired
}